<template>
  <v-container
    fluid
    style="
      margin-top: 0%;
      padding: 0% 0% 0 0;
      max-height: 100vh;
      overflow: hidden;
    "
  >
    <v-row style="margin: 0; padding: 0; position: relative">
      <v-col cols="12" class="pa-0">
        <GlobalNav />
      </v-col>
      <v-col
        cols="12"
        style="height: 100%"
        class="pa-0 d-flex align-start ga-6"
      >
        <SideBar />
        <div class="mt-6 msgbox">
          <BreadCrumb :linksData="linksData" class="mb-5" />
          <v-container fluid class="pa-0" style="height: 100vh">
            <v-row
              no-gutters
              class="w-100"
              style="
                border: 1px solid #eee;
                border-left: none;
                border-radius: 0 34px 0 0;
              "
            >
              <!-- Sidebar (Conversations List) -->
              <v-col
                cols="12"
                sm="4"
                class="pa-4 chatside"
                style="
                  border: 1px solid #eee;
                  overflow-y: hidden;
                  border-top: none;
                  border-bottom: none;
                  border-radius: 0 0px 34px 0;
                "
              >
                <!-- Title -->
                <div class="d-flex justify-space-between align-center">
                  <div class="d-flex align-center">
                    <p class="text-h6 font-weight-bold mr-2">Messages</p>
                    <!-- Socket Connection Status Indicator -->
                    <v-tooltip bottom>
                      <template #activator="{ props }">
                        <v-chip
                          v-bind="props"
                          :color="socketConnected ? 'success' : 'error'"
                          size="x-small"
                          class="ml-2"
                        >
                          <v-icon size="10" class="mr-1">
                            {{ socketConnected ? 'mdi-circle' : 'mdi-circle-outline' }}
                          </v-icon>
                          {{ socketConnected ? 'Live' : 'Offline' }}
                        </v-chip>
                      </template>
                      <span>{{ socketConnected ? 'Real-time connection active' : 'Attempting to reconnect...' }}</span>
                    </v-tooltip>
                  </div>
                  <SelectAccId
                    ref="accountSelector"
                    @accounts-selected="handleAccountsSelected"
                    @sync-complete="refreshConversations"
                  />
                </div>

                <!-- Search Field -->
                <div class="d-flex align-center mb-2">
                  <v-menu
                    v-model="showFilterMenu"
                    :close-on-content-click="false"
                    offset-y
                  >
                    <v-card class="pa-2" style="min-width: 200px">
                      <v-row justify="center" class="mt-2">
                        <v-pagination
                          v-if="totalPages > 1"
                          v-model="currentPage"
                          :length="totalPages"
                          @update:modelValue="getConversations"
                          color="teal"
                          density="comfortable"
                        />
                      </v-row>
                    </v-card>
                  </v-menu>
                  <div class="my-2 w-100 search-conversation">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="20px"
                      viewBox="0 -960 960 960"
                      width="20px"
                      fill="#999999"
                    >
                      <path
                        d="M765-144 526-383q-30 22-65.79 34.5-35.79 12.5-76.18 12.5Q284-336 214-406t-70-170q0-100 70-170t170-70q100 0 170 70t70 170.03q0 40.39-12.5 76.18Q599-464 577-434l239 239-51 51ZM384-408q70 0 119-49t49-119q0-70-49-119t-119-49q-70 0-119 49t-49 119q0 70 49 119t119 49Z"
                      />
                    </svg>
                    <input
                      type="text"
                      placeholder="Search"
                      v-model="searchQuery"
                    />
                  </div>
                </div>
                <!-- Conversation List -->
                <!-- مكان الـ pagination القديم داخل v-list -->
                <v-list
                  ref="conversationList"
                  nav
                  dense
                  style="max-height: 30rem; overflow-y: scroll"
                  @scroll.passive="handleScroll"

                >
                  <template v-if="isLoadingConversations">
                    <v-skeleton-loader
                      type="list-item-avatar-two-line"
                      class="mx-2 my-1"
                      v-for="n in 6"
                      :key="n"
                    />
                  </template>
                  <v-list-item v-if="!selectedDmAccounts.length && !isLoadingConversations">
                    <v-list-item-title>Select at least one account</v-list-item-title>
                    <v-list-item-subtitle>Your unified inbox will appear here.</v-list-item-subtitle>
                  </v-list-item>
                  <template v-if="filteredConversations.length > 0">
                    <v-list-item
                      v-for="(
                        conversation, index
                      ) in filteredConversations.filter(
                        (c) => c && c.sender_name !== 'Unknown'
                      )"
                      :key="`${conversation.platform_account_id}-${conversation.conversation_id || index}`"
                      :active="
                        selectedConversation?.conversation_id ===
                          conversation.conversation_id &&
                        selectedConversation?.platform_account_id ===
                          conversation.platform_account_id
                      "
                      @click="selectConversation(conversation)"
                      class="rounded-lg my-1"
                    >
                      <template #prepend>
                        <div class="position-relative mr-4">
                          <v-avatar size="40">
                            <v-img :src="conversation.sender_profile_picture" />
                          </v-avatar>
                          <div class="badge"></div>
                        </div>
                      </template>

                      <v-list-item-title class="font-weight-medium">
                        {{ conversation.sender_name }}
                      </v-list-item-title>
                      <div class="d-flex align-center ga-1 text-caption text-medium-emphasis">
                        <v-icon size="14">{{ conversationPlatformIcon(conversation.platform) }}</v-icon>
                        {{ conversation.account_name }}
                      </div>
                      <v-list-item-subtitle
                        class="text-truncate"
                        style="max-width: 200px"
                      >
                        {{ conversation.last_message_text }}
                      </v-list-item-subtitle>
                    </v-list-item>
                  </template>
                  <template v-if="whatsappChats && whatsappChats.length > 0">
                    <v-list-item
                      v-for="(chat, index) in whatsappChats"
                      :key="index"
                      :active="selectedWhatsappChat === chat.id"
                      @click="selectWhatsAppChat(chat)"
                      class="rounded-lg my-1"
                    >
                      <template #prepend>
                        <div class="position-relative mr-4">
                          <v-avatar size="40">
                            <v-img :src="chat.profilePicUrl" />
                          </v-avatar>
                          <div class="badge"></div>
                        </div>
                      </template>

                      <v-list-item-title class="font-weight-medium">
                        {{ chat.name }}
                        <!-- Contact Type Badge -->
                        <v-chip
                          v-if="chat.id && chat.id.includes('@lid')"
                          size="x-small"
                          color="blue lighten-4"
                          text-color="blue darken-2"
                          class="ml-1"
                        >
                          LID
                        </v-chip>
                        <v-chip
                          v-else-if="chat.id && chat.id.includes('@c.us')"
                          size="x-small"
                          color="purple lighten-4"
                          text-color="purple darken-2"
                          class="ml-1"
                        >
                          Phone
                        </v-chip>
                        <v-chip
                          v-else-if="chat.id && chat.id.includes('@g.us')"
                          size="x-small"
                          color="green lighten-4"
                          text-color="green darken-2"
                          class="ml-1"
                        >
                          Group
                        </v-chip>
                      </v-list-item-title>
                      <v-list-item-subtitle
                        class="text-truncate"
                        style="max-width: 200px"
                      >
                        {{ chat.lastMessage }}
                      </v-list-item-subtitle>
                    </v-list-item>
                  </template>

                  <v-skeleton-loader
                    v-if="isLoadingMore"
                    type="list-item-avatar-two-line"
                    class="mx-2 my-1"
                  />
                </v-list>
              </v-col>
              <!-- Chat Window -->
              <v-col cols="12" sm="8" class="d-flex flex-column chatwindow">
                <template v-if="selectedConversation">
                  <v-toolbar
                    flat
                    height="70"
                    class="px-4"
                    style="
                      background-color: #fff;
                      border-bottom: 1px solid #eee;
                      border: none;
                      border-radius: 0 34px 0px 0px;
                      box-shadow: 0px 2px 20px 0px #6666661f;
                    "
                  >
                    <!-- Avatar + Status -->
                    <div class="mr-3 position-relative">
                      <img
                        width="48"
                        height="48"
                        style="border-radius: 50%"
                        :src="
                          selectedConversation?.sender_profile_picture ||
                          selectedConversation?.profilePicUrl
                        "
                      />
                      <div class="badge"></div>
                    </div>

                    <!-- User Info -->
                    <div class="d-flex flex-column justify-center">
                      <div class="font-weight-medium text-body-1 d-flex align-center">
                        <span>{{
                          selectedConversation?.sender_name ||
                          selectedConversation?.name
                        }}</span>
                        <!-- Contact Type Badge in Header -->
                        <v-chip
                          v-if="selectedConversation?.id && selectedConversation.id.includes('@lid')"
                          size="x-small"
                          color="blue lighten-4"
                          text-color="blue darken-2"
                          class="ml-2"
                        >
                          <v-icon size="12" class="mr-1">mdi-identifier</v-icon>
                          WhatsApp LID
                        </v-chip>
                        <v-chip
                          v-else-if="selectedConversation?.id && selectedConversation.id.includes('@c.us')"
                          size="x-small"
                          color="purple lighten-4"
                          text-color="purple darken-2"
                          class="ml-2"
                        >
                          <v-icon size="12" class="mr-1">mdi-phone</v-icon>
                          Phone
                        </v-chip>
                        <v-chip
                          v-else-if="selectedConversation?.id && selectedConversation.id.includes('@g.us')"
                          size="x-small"
                          color="green lighten-4"
                          text-color="green darken-2"
                          class="ml-2"
                        >
                          <v-icon size="12" class="mr-1">mdi-account-group</v-icon>
                          Group
                        </v-chip>
                      </div>
                      <div class="text-caption text-grey">Reply to message</div>
                    </div>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-divider />
                  <div
                    ref="messageContainer"
                    class="flex-grow-1 overflow-y-auto pa-4"
                    @scroll.passive="handleMessageScroll"
                  >
                    <div
                      v-for="(msg, index) in selectedConversation?.messages ||
                      []"
                      :key="index"
                      class="mb-6"
                    >
                      <div
                        :class="
                          msg.direction === 'outbound'
                            ? 'd-flex justify-end'
                            : 'd-flex justify-start'
                        "
                      >
                        <div
                          class="d-inline-flex align-center"
                          style="max-width: 75%; position: relative"
                        >
                          <!-- إذا كانت صورة -->
                          <template
                            v-if="
                              msg?.type === 'image' ||
                              (msg?.type === 'file' &&
                                msg?.attachment?.mime_type?.includes(
                                  'image'
                                )) ||
                              msg?.type === 'image'
                            "
                          >
                            <div>
                              <v-img
                                :src="msg?.attachment?.url || msg?.media_url"
                                width="200"
                                height="200"
                                class="rounded-lg cursor-pointer"
                                cover
                                @click="
                                  openImageDialog(
                                    msg?.attachment?.url || msg?.media_url
                                  )
                                "
                              />
                              <v-card
                                v-if="msg.caption"
                                :color="
                                  msg.direction === 'outbound'
                                    ? 'teal darken-2'
                                    : '#F2F2F2'
                                "
                                :text-color="
                                  msg.direction === 'outbound' ? 'white' : 'black'
                                "
                                class="pa-2 mt-1"
                                style="border-radius: 18px; font-size: 15px"
                                flat
                              >
                                {{ msg.caption }}
                              </v-card>
                            </div>
                          </template>

                          <!-- إذا كان صوت -->
                          <template
                            v-if="
                              msg?.type === 'audio' ||
                              (msg?.type === 'file' &&
                                msg?.attachment?.mime_type?.includes(
                                  'audio'
                                )) ||
                              msg?.type === 'audio'
                            "
                          >
                            <div>
                              <audio controls :src="msg?.attachment?.url || msg?.media_url"></audio>
                              <v-card
                                v-if="msg.caption"
                                :color="
                                  msg.direction === 'outbound'
                                    ? 'teal darken-2'
                                    : '#F2F2F2'
                                "
                                :text-color="
                                  msg.direction === 'outbound' ? 'white' : 'black'
                                "
                                class="pa-2 mt-1"
                                style="border-radius: 18px; font-size: 15px"
                                flat
                              >
                                {{ msg.caption }}
                              </v-card>
                            </div>
                          </template>
                          <!-- إذا كان فيديو -->
                          <template
                            v-if="
                              msg.type === 'video' ||
                              (msg?.type === 'file' &&
                                msg?.attachment?.mime_type?.includes(
                                  'video'
                                )) ||
                              msg?.type === 'video'
                            "
                          >
                            <div>
                              <video
                                controls
                                width="200"
                                height="200"
                                class="rounded-lg"
                                style="object-fit: cover"
                              >
                                <source
                                  :src="msg?.attachment?.url || msg?.media_url"
                                  type="video/mp4"
                                />
                                Your browser does not support the video element.
                              </video>
                              <v-card
                                v-if="msg.caption"
                                :color="
                                  msg.direction === 'outbound'
                                    ? 'teal darken-2'
                                    : '#F2F2F2'
                                "
                                :text-color="
                                  msg.direction === 'outbound' ? 'white' : 'black'
                                "
                                class="pa-2 mt-1"
                                style="border-radius: 18px; font-size: 15px"
                                flat
                              >
                                {{ msg.caption }}
                              </v-card>
                            </div>
                          </template>

                          <!-- إذا كانت رسالة نصية -->
                          <template v-else>
                            <v-card
                              v-if="msg.type === 'text' || msg.type === 'chat'"
                              :color="
                                msg.direction === 'outbound'
                                  ? 'teal darken-2'
                                  : '#F2F2F2'
                              "
                              :text-color="
                                msg.direction === 'outbound' ? 'white' : 'black'
                              "
                              class="pa-3"
                              style="border-radius: 18px; font-size: 15px"
                              flat
                            >
                              {{ msg.text || msg.body }}
                            </v-card>
                          </template>
                        </div>
                      </div>
                      <div
                        :class="
                          msg.direction === 'outbound'
                            ? 'text-right mr-4'
                            : 'text-left ml-4'
                        "
                      >
                        <small class="text-grey">{{
                          formatTime(msg.sent_at)
                        }}</small>
                      </div>
                    </div>
                  </div>
                  <v-divider />
                  <div class="d-flex ga-10 pa-6">
                    <!-- Input Box -->
                    <div
                      class="d-flex item-center justify-space-between ga-2"
                      style="width: 95%"
                    >
                      <v-text-field
                        @keyup.enter="sendMessage"
                        v-model="newMessage"
                        placeholder="Type something here..."
                        hide-details
                        density="comfortable"
                        variant="outlined"
                        rounded
                        class="flex-grow-1"
                        style="background: white; border-radius: 12px"
                      >
                        <template #append-inner>
                          <!-- Emoji -->
                          <v-menu v-model="showEmojiPicker" offset-y>
                            <template #activator="{ props }">
                              <v-icon
                                v-bind="props"
                                size="25"
                                class="mx-1"
                                color="#666666"
                              >
                                mdi-emoticon-happy-outline
                              </v-icon>
                              <!-- Record -->
                              <v-btn
                                elevation="0"
                                variant="text"
                                :class="{ 'recording-animation': isRecording }"
                                @click="
                                  isRecording
                                    ? stopRecording()
                                    : startRecording()
                                "
                              >
                                <svg
                                  v-if="!isRecording"
                                  xmlns="http://www.w3.org/2000/svg"
                                  height="25px"
                                  viewBox="0 -960 960 960"
                                  width="25px"
                                  fill="#666666"
                                >
                                  <path
                                    d="M480-384q-50 0-85-35t-35-85v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q0 50-35 85t-85 35Zm0-240Zm-36 480v-99q-98.8-13.1-163.4-87.05Q216-404 216-504h72q0 79.68 56.23 135.84 56.22 56.16 136 56.16Q560-312 616-368.16q56-56.16 56-135.84h72q0 100-64.6 173.95Q614.8-256.1 516-243v99h-72Zm36-312q20.4 0 34.2-13.8Q528-483.6 528-504v-240q0-20.4-13.8-34.2Q500.4-792 480-792q-20.4 0-34.2 13.8Q432-764.4 432-744v240q0 20.4 13.8 34.2Q459.6-456 480-456Z"
                                  />
                                </svg>
                                <svg
                                  v-else
                                  xmlns="http://www.w3.org/2000/svg"
                                  height="25px"
                                  viewBox="0 -960 960 960"
                                  width="25px"
                                  fill="#FF0000"
                                >
                                  <path
                                    d="M336-336h288v-288H336v288ZM480.28-96Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z"
                                  />
                                </svg>
                              </v-btn>

                              <!-- Upload file -->
                              <v-icon
                                size="25"
                                class="mx-1"
                                color="#666666"
                                @click.stop="triggerFileSelect"
                              >
                                mdi-paperclip
                              </v-icon>
                            </template>
                            <v-card>
                              <div
                                v-if="showEmojiPicker"
                                class="emoji-picker-wrapper"
                              >
                                <emoji-picker
                                  @emoji-click="onEmojiClick"
                                ></emoji-picker>
                              </div>
                            </v-card>
                          </v-menu>
                        </template>
                      </v-text-field>
                      <div class="d-flex item-center align-center">
                        <input
                          ref="fileInput"
                          type="file"
                          accept="image/*,video/*,audio/*"
                          @change="handleFileChange"
                          style="display: none"
                        />

                        <!-- Preview Selected Image -->
                        <v-avatar v-if="selectedFile" size="28" class="mx-1">
                          <v-img :src="previewImage" alt="selected file" />
                        </v-avatar>
                        <v-skeleton-loader
                          v-if="avatarSkeleton"
                          type="avatar"
                        />
                      </div>
                    </div>
                    <!-- 24 Hour Warning Badge -->
                    <v-tooltip v-if="currentPlatform === 'meta' && !canSendMessage" bottom>
                      <template #activator="{ on, attrs }">
                        <v-chip
                          small
                          color="warning"
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon small left>mdi-clock-alert-outline</v-icon>
                          {{ timeSinceLastInboundShort }}
                        </v-chip>
                      </template>
                      <span>آخر رسالة من العميل كانت منذ {{ timeSinceLastInbound }}. Meta لا يسمح بإرسال رسائل عادية بعد 24 ساعة.</span>
                    </v-tooltip>
                    <!-- Send Button -->
                    <v-btn
                      :disabled="
                        (!newMessage.trim() && !selectedFile && !avatarSkeleton) ||
                        (currentPlatform === 'meta' && !canSendMessage)
                      "
                      :style="{
                        cursor:
                          (!newMessage.trim() && !selectedFile && !avatarSkeleton) ||
                          (currentPlatform === 'meta' && !canSendMessage)
                            ? 'not-allowed'
                            : 'pointer',
                      }"
                      :color="currentPlatform === 'meta' && !canSendMessage ? 'grey' : 'teal lighten-2'"
                      class="rounded-lg"
                      style="width: 48px; height: 48px"
                      @click="sendMessage"
                      @enter="sendMessage"
                    >
                      <v-icon color="white">mdi-send</v-icon>
                    </v-btn>
                  </div>
                </template>
                <template v-else>
                  <v-card
                    elevation="0"
                    class="pa-2 h-100 d-flex align-center justify-center flex-column"
                  >
                    <img
                      class="mb-4 d-block"
                      src="@/assets/images/empty-chat.svg"
                      alt="Empty Conversation"
                    />
                    <p
                      class="mb-2"
                      style="font-size: 20px; color: #237276; font-weight: 600"
                    >
                      No Conversation Selected
                    </p>
                    <p style="font-size: 16px; color: #1a1a1a">
                      Start a conversation by selecting a conversation from the
                      list above.
                    </p>
                  </v-card>
                </template>
                <v-dialog v-model="previewDialog" max-width="600px">
                  <v-card>
                    <v-img
                      :src="previewDialogImage"
                      aspect-ratio="1"
                      max-height="90vh"
                      class="rounded"
                      cover
                    />
                  </v-card>
                </v-dialog>
                <!-- 24 Hour Warning Dialog -->
                <v-dialog v-model="show24HourWarning" max-width="500px" persistent>
                  <v-card>
                    <v-card-title class="text-h6 d-flex align-center">
                      <v-icon color="warning" class="mr-2">mdi-alert</v-icon>
                      تحذير: نافذة الـ 24 ساعة
                    </v-card-title>
                    <v-card-text>
                      <p class="mb-3">
                        آخر رسالة من العميل كانت منذ <strong>{{ timeSinceLastInbound }}</strong>.
                      </p>
                      <p>
                        Meta لا يسمح بإرسال رسائل عادية بعد مرور 24 ساعة على آخر رسالة من العميل.
                      </p>
                      <p class="mt-3 text-caption text-grey">
                        لإرسال رسالة، يجب استخدام Template Message أو انتظار رد من العميل.
                      </p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="show24HourWarning = false">
                        فهمت
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import GlobalNav from "@/components/layout/GlobalNav.vue";
import SideBar from "@/components/layout/SideBar.vue";
import BreadCrumb from "@/components/layout/BreadCrumb.vue";
import SelectAccId from "@/views/MessageCenter/SelectAccId.vue";
import socket from "@/core/socketIo.js";
import { messageCenterApi } from "@/core/messageCenterApi";
import "emoji-picker-element";
import MicRecorder from "mic-recorder-to-mp3";
export default {
  components: {
    GlobalNav,
    SideBar,
    BreadCrumb,
    SelectAccId,
  },
  data() {
    return {
      recorder: new MicRecorder({ bitRate: 128 }),
      isRecording: false,
      audioUrl: null,
      linksData: [
        { name: "home", link: "/" },
        { name: "MessagesCenter", link: "/messages-center" },
      ],
      conversations: [],
      currentPage: 1,
      newMessageSound: null,
      totalPages: 1,
      isLoadingMore: false,
      selectedPlatform: "all",
      selectedConversation: null,
      showFilterMenu: false,
      selectedFilterType: "all",
      messageContainer: null,
      searchQuery: "",
      hoverIndex: null,
      previewImage: null, // to hold base64 image preview
      selectedFile: null, // to hold the actual file object
      newMessage: "",
      showEmojiPicker: false,
      emojiList: [],
      selectedDmAccounts: [],
      activeDmAccount: null,
      accountSelectionTimer: null,
      isLoadingConversations: false,
      messagesPage: 1,
      hasMoreMessages: true,
      isLoadingMessages: false,
      previewDialog: false,
      previewDialogImage: null,
      sender_id: null,
      avatarSkeleton: false,
      whatsappChats: [],
      whatsappPage: 1,
      whatsappPerPage: 30,
      whatsappTotalPages: 1,
      whatsappHasMore: true,
      currentPlatform: "whatsapp", 
      selectedWhatsappChat: null,
      whats_app_number: null,
      show24HourWarning: false,
      hoursSinceLastInbound: 0,
      // Socket connection management
      socketConnected: false,
      socketHealthCheck: null,
      reconnectAttempts: 0,
      maxReconnectAttempts: 5,
    };
  },
  computed: {
    canSendMessage() {
      // For WhatsApp, always allow
      if (this.currentPlatform === "whatsapp") {
        return true;
      }
      
      // For Meta platforms, check 24-hour window
      if (!this.selectedConversation || !this.selectedConversation.messages) {
        return true;
      }
      
      // Find last inbound message
      const inboundMessages = this.selectedConversation.messages.filter(
        (msg) => msg.direction === "inbound"
      );
      
      if (inboundMessages.length === 0) {
        return true; // No inbound messages, can send
      }
      
      // Get the most recent inbound message
      const lastInbound = inboundMessages.sort((a, b) => {
        return new Date(b.sent_at) - new Date(a.sent_at);
      })[0];
      
      if (!lastInbound || !lastInbound.sent_at) {
        return true;
      }
      
      const lastInboundTime = new Date(lastInbound.sent_at);
      const now = new Date();
      const hoursDiff = (now - lastInboundTime) / (1000 * 60 * 60);
      
      // If more than 24 hours, cannot send regular message
      return hoursDiff < 24;
    },
    filteredConversations() {
      let result = this.conversations;
      if (this.selectedPlatform !== "all") {
        result = result.filter(
          (convo) => convo.platform === this.selectedPlatform
        );
      }
      if (this.searchQuery.trim() !== "") {
        const query = this.searchQuery.trim().toLowerCase();
        result = result.filter((convo) => {
          const nameMatch =
            convo.sender_name?.toLowerCase()?.includes(query) || false;
          const textMatch =
            convo.last_message_text?.toLowerCase()?.includes(query) || false;
          return nameMatch || textMatch;
        });
      }
      if (this.selectedFilterType === "unread") {
        result = result.filter((convo) => convo.unread);
      } else if (this.selectedFilterType === "read") {
        result = result.filter((convo) => !convo.unread);
      }
      return result;
    },
    timeSinceLastInbound() {
      if (this.hoursSinceLastInbound === 0) {
        return '';
      }
      
      if (this.hoursSinceLastInbound < 24) {
        return `${this.hoursSinceLastInbound} ساعة`;
      }
      
      const days = Math.floor(this.hoursSinceLastInbound / 24);
      const remainingHours = this.hoursSinceLastInbound % 24;
      
      if (remainingHours === 0) {
        return `${days} ${days === 1 ? 'يوم' : 'أيام'}`;
      }
      
      return `${days} ${days === 1 ? 'يوم' : 'أيام'} و ${remainingHours} ساعة`;
    },
    timeSinceLastInboundShort() {
      if (this.hoursSinceLastInbound === 0) {
        return '';
      }
      
      if (this.hoursSinceLastInbound < 24) {
        return `${this.hoursSinceLastInbound}h`;
      }
      
      const days = Math.floor(this.hoursSinceLastInbound / 24);
      return `${days}d`;
    },
  },
  watch: {
    selectedConversation: {
      handler(newVal) {
        if (newVal && newVal.messages) {
          this.updateHoursSinceLastInbound();
        } else {
          this.hoursSinceLastInbound = 0;
        }
      },
      immediate: true,
      deep: true,
    },
    'selectedConversation.messages': {
      handler() {
        this.updateHoursSinceLastInbound();
      },
      deep: true,
    },
  },
  methods: {
    // Socket connection health check
    setupHealthCheck() {
      // Check connection every 30 seconds
      this.socketHealthCheck = setInterval(() => {
        if (!socket.connected && this.reconnectAttempts < this.maxReconnectAttempts) {
          console.warn('⚠️ Socket disconnected, attempting to reconnect...');
          this.reconnectAttempts++;
          socket.connect();
        } else if (socket.connected) {
          this.reconnectAttempts = 0; // Reset on successful connection
          this.socketConnected = true;
        }
      }, 30000); // 30 seconds
    },
    updateHoursSinceLastInbound() {
      if (this.currentPlatform === "whatsapp" || !this.selectedConversation || !this.selectedConversation.messages) {
        this.hoursSinceLastInbound = 0;
        return;
      }
      
      const inboundMessages = this.selectedConversation.messages.filter(
        (msg) => msg.direction === "inbound"
      );
      
      if (inboundMessages.length === 0) {
        this.hoursSinceLastInbound = 0;
        return;
      }
      
      const lastInbound = inboundMessages.sort((a, b) => {
        return new Date(b.sent_at) - new Date(a.sent_at);
      })[0];
      
      if (!lastInbound || !lastInbound.sent_at) {
        this.hoursSinceLastInbound = 0;
        return;
      }
      
      const lastInboundTime = new Date(lastInbound.sent_at);
      const now = new Date();
      const hoursDiff = (now - lastInboundTime) / (1000 * 60 * 60);
      this.hoursSinceLastInbound = Math.floor(hoursDiff);
    },
    formatTime(isoTime) {
      if (!isoTime || isNaN(new Date(isoTime))) return "";
      const date = new Date(isoTime);
      return date.toLocaleString("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    // WhatsApp-specific helper methods
    checkWhatsAppConversationMatch(messageData) {
      // Check if this is a WhatsApp message (@c.us, @lid, @g.us)
      const isWhatsApp = 
        (messageData.conversation_id && (
          messageData.conversation_id.includes("@c.us") || 
          messageData.conversation_id.includes("@lid") ||
          messageData.conversation_id.includes("@g.us")
        )) ||
        (messageData.chat_id && (
          messageData.chat_id.includes("@c.us") || 
          messageData.chat_id.includes("@lid") ||
          messageData.chat_id.includes("@g.us")
        )) ||
        (messageData.from && (
          messageData.from.includes("@c.us") || 
          messageData.from.includes("@lid") ||
          messageData.from.includes("@g.us")
        )) ||
        (messageData.sender_id && (
          messageData.sender_id.includes("@c.us") || 
          messageData.sender_id.includes("@lid") ||
          messageData.sender_id.includes("@g.us")
        )) ||
        (messageData.to && (
          messageData.to.includes("@c.us") || 
          messageData.to.includes("@lid") ||
          messageData.to.includes("@g.us")
        ));
      
      if (!isWhatsApp) return null;
      
      // Primary: Use conversation_id or chat_id
      const conversationId = messageData.conversation_id || messageData.chat_id;
      
      // Find matching chat in whatsappChats
      if (conversationId) {
        const matchingChat = this.whatsappChats.find(
          (chat) =>
            chat.conversation_id === conversationId ||
            chat.chat_id === conversationId ||
            chat.id === conversationId ||
            (chat.wid && chat.wid === conversationId)
        );
        if (matchingChat) return matchingChat;
      }
      
      // Fallback: Use sender_id for inbound, to for outbound
      if (messageData.direction === "inbound" && messageData.sender_id) {
        const matchingChat = this.whatsappChats.find(
          (chat) =>
            chat.id === messageData.sender_id ||
            chat.wid === messageData.sender_id ||
            chat.conversation_id === messageData.sender_id ||
            chat.chat_id === messageData.sender_id
        );
        if (matchingChat) return matchingChat;
      }
      
      if (messageData.direction === "outbound" && messageData.to) {
        const matchingChat = this.whatsappChats.find(
          (chat) =>
            chat.id === messageData.to ||
            chat.wid === messageData.to ||
            chat.conversation_id === messageData.to ||
            chat.chat_id === messageData.to
        );
        if (matchingChat) return matchingChat;
      }
      
      // Legacy fallback: Use from field (support all WhatsApp ID types)
      if (messageData.from && (
        messageData.from.includes("@c.us") || 
        messageData.from.includes("@lid") ||
        messageData.from.includes("@g.us")
      )) {
        const matchingChat = this.whatsappChats.find(
          (chat) =>
            chat.id === messageData.from ||
            chat.wid === messageData.from
        );
        if (matchingChat) return matchingChat;
      }
      
      return null;
    },
    isWhatsAppDuplicate(messageData) {
      // Check if this is a WhatsApp message (@c.us, @lid, @g.us)
      const isWhatsApp = 
        (messageData.conversation_id && (
          messageData.conversation_id.includes("@c.us") ||
          messageData.conversation_id.includes("@lid") ||
          messageData.conversation_id.includes("@g.us")
        )) ||
        (messageData.chat_id && (
          messageData.chat_id.includes("@c.us") ||
          messageData.chat_id.includes("@lid") ||
          messageData.chat_id.includes("@g.us")
        )) ||
        (messageData.from && (
          messageData.from.includes("@c.us") ||
          messageData.from.includes("@lid") ||
          messageData.from.includes("@g.us")
        )) ||
        this.currentPlatform === "whatsapp";
      
      if (!isWhatsApp) return false;
      
      // Primary check: Use message_id
      if (messageData.message_id) {
        // Check in selected conversation messages
        if (this.selectedConversation && Array.isArray(this.selectedConversation.messages)) {
          const exists = this.selectedConversation.messages.some(
            (msg) => msg.message_id === messageData.message_id
          );
          if (exists) return true;
        }
        
        // Check in whatsappChats messages
        for (const chat of this.whatsappChats) {
          if (Array.isArray(chat.messages)) {
            const exists = chat.messages.some(
              (msg) => msg.message_id === messageData.message_id
            );
            if (exists) return true;
          }
        }
      }
      
      return false;
    },
    normalizeWhatsAppMessage(messageData) {
      // Normalize WhatsApp message to consistent format
      const normalized = {
        message_id: messageData.message_id || null,
        conversation_id: messageData.conversation_id || messageData.chat_id || null,
        chat_id: messageData.chat_id || messageData.conversation_id || null,
        direction: messageData.direction || (messageData.from === "me" || messageData.from !== messageData.sender_id ? "outbound" : "inbound"),
        sender_id: messageData.sender_id || messageData.from || null,
        from: messageData.from || messageData.sender_id || null,
        to: messageData.to || null,
        text: messageData.text || messageData.body || messageData.content || "",
        body: messageData.body || messageData.text || messageData.content || "",
        type: messageData.type || "text",
        attachment: messageData.attachment || null,
        media_url: messageData.media_url || (messageData.attachment && messageData.attachment.url) || null,
        caption: messageData.caption || null,
      };
      
      // Handle timestamp (already in milliseconds)
      if (messageData.timestamp) {
        // If timestamp is in milliseconds (>= 1e12), use as is
        // If timestamp is in seconds (< 1e12), convert to milliseconds
        const timestamp = messageData.timestamp >= 1e12 
          ? messageData.timestamp 
          : messageData.timestamp * 1000;
        normalized.sent_at = new Date(timestamp).toISOString();
        normalized.timestamp = timestamp;
      } else if (messageData.sent_at) {
        normalized.sent_at = messageData.sent_at;
        normalized.timestamp = new Date(messageData.sent_at).getTime();
      } else {
        normalized.sent_at = new Date().toISOString();
        normalized.timestamp = Date.now();
      }
      
      return normalized;
    },
    updateWhatsAppChatList(messageData) {
      const normalized = this.normalizeWhatsAppMessage(messageData);
      const matchingChat = this.checkWhatsAppConversationMatch(messageData);
      
      if (matchingChat) {
        // Check if this is the currently selected conversation
        const isSelectedChat = this.selectedConversation && (
          this.selectedConversation.id === matchingChat.id ||
          this.selectedConversation.conversation_id === matchingChat.conversation_id ||
          this.selectedConversation.chat_id === matchingChat.chat_id ||
          this.selectedConversation.id === matchingChat.conversation_id ||
          this.selectedConversation.id === matchingChat.chat_id
        );
        
        // Update existing chat
        if (this.$set) {
          this.$set(matchingChat, 'lastMessage', normalized.text || normalized.body || "[Media]");
          this.$set(matchingChat, 'timestamp', normalized.timestamp);
          // Only mark as unread if it's an inbound message and not the selected conversation
          if (normalized.direction === "inbound" && !isSelectedChat) {
            this.$set(matchingChat, 'unread', true);
            this.$set(matchingChat, 'unreadCount', (matchingChat.unreadCount || 0) + 1);
          }
        } else {
          matchingChat.lastMessage = normalized.text || normalized.body || "[Media]";
          matchingChat.timestamp = normalized.timestamp;
          // Only mark as unread if it's an inbound message and not the selected conversation
          if (normalized.direction === "inbound" && !isSelectedChat) {
            matchingChat.unread = true;
            matchingChat.unreadCount = (matchingChat.unreadCount || 0) + 1;
          }
        }
        
        // Move chat to top
        const index = this.whatsappChats.findIndex(
          (chat) =>
            chat.id === matchingChat.id ||
            chat.conversation_id === matchingChat.conversation_id ||
            chat.chat_id === matchingChat.chat_id
        );
        if (index !== -1 && index !== 0) {
          const updated = this.whatsappChats.splice(index, 1)[0];
          this.whatsappChats.unshift(updated);
        }
      } else {
        // Create new chat
        const conversationId = normalized.conversation_id || normalized.chat_id || normalized.from || normalized.sender_id;
        const newChat = {
          id: conversationId,
          conversation_id: normalized.conversation_id || normalized.chat_id,
          chat_id: normalized.chat_id || normalized.conversation_id,
          wid: conversationId,
          name: messageData.name || conversationId,
          profilePicUrl: messageData.profilePic || messageData.profilePicUrl || null,
          lastMessage: normalized.text || normalized.body || "[Media]",
          unread: normalized.direction === "inbound",
          unreadCount: normalized.direction === "inbound" ? 1 : 0,
          timestamp: normalized.timestamp,
          messages: [],
        };
        this.whatsappChats.unshift(newChat);
      }
    },
    addMessageToSelectedConversation(data, timestamp) {
      if (!this.selectedConversation) {
        console.warn("❌ No conversation selected");
        return;
      }

      if (!Array.isArray(this.selectedConversation.messages)) {
        // Use Vue.set if available, otherwise direct assignment
        if (this.$set) {
          this.$set(this.selectedConversation, 'messages', []);
        } else {
          this.selectedConversation.messages = [];
        }
      }

      // For WhatsApp messages, use WhatsApp-specific duplicate detection
      if (this.currentPlatform === "whatsapp" || 
          (data.conversation_id && (
            data.conversation_id.includes("@c.us") ||
            data.conversation_id.includes("@lid") ||
            data.conversation_id.includes("@g.us")
          )) ||
          (data.chat_id && (
            data.chat_id.includes("@c.us") ||
            data.chat_id.includes("@lid") ||
            data.chat_id.includes("@g.us")
          ))) {
        if (this.isWhatsAppDuplicate(data)) {
          console.log("⚠️ WhatsApp duplicate message detected, skipping:", data.message_id);
          return;
        }
      }

      const messageText = data.text || data.body || data.content || "";
      const messageDirection = data.direction || "inbound";
      
      // Check if message already exists by message_id (for all platforms)
      const existsByMessageId = data.message_id && this.selectedConversation.messages.some(
        (msg) => msg.message_id === data.message_id
      );
      
      // Check if this is a duplicate of a recently sent message (outbound -> inbound)
      // This happens when we send a message and socket echoes it back
      // Find the matching outbound message to update it instead of adding duplicate
      let matchingOutboundMessage = null;
      if (messageDirection === "inbound") {
        matchingOutboundMessage = this.selectedConversation.messages.find((msg) => {
          // Check if there's an outbound message with same text sent recently (within 5 seconds)
          if (msg.direction === "outbound" && 
              !msg.message_id && // Only match messages without message_id (recently sent)
              (msg.text === messageText || msg.body === messageText)) {
            const msgTime = new Date(msg.sent_at).getTime();
            const newMsgTime = new Date(data.sent_at || timestamp).getTime();
            const timeDiff = Math.abs(newMsgTime - msgTime);
            // If messages are within 5 seconds and have same text, it's likely a duplicate
            return timeDiff < 5000;
          }
          return false;
        });
      }

      // If we found a matching outbound message, update it with message_id instead of adding duplicate
      if (matchingOutboundMessage) {
        console.log("🔄 Updating outbound message with message_id instead of adding duplicate");
        matchingOutboundMessage.message_id = data.message_id;
        matchingOutboundMessage.isTemporary = false;
        // Update the messages array to trigger reactivity
        const updatedMessages = [...this.selectedConversation.messages];
        if (this.$set) {
          this.$set(this.selectedConversation, 'messages', updatedMessages);
        } else {
          this.selectedConversation.messages = updatedMessages;
        }
        return; // Don't add a new message
      }

      if (!existsByMessageId) {
        const normalizedMessage = {
          text: messageText,
          body: messageText,
          direction: messageDirection,
          type: data.type || "text",
          sent_at: data.sent_at || timestamp,
          message_id: data.message_id || null,
          sender_id: data.sender_id || null,
          sender_name: data.sender_name || null,
          attachment: data.attachment || null,
          media_url: data.media_url || (data.attachment && data.attachment.url) || null,
          caption: data.caption || null,
          conversation_id: data.conversation_id || data.chat_id || null,
          chat_id: data.chat_id || data.conversation_id || null,
        };

        const updatedMessages = [...this.selectedConversation.messages, normalizedMessage];
        
        // Use Vue.set if available, otherwise direct assignment
        if (this.$set) {
          this.$set(this.selectedConversation, 'messages', updatedMessages);
        } else {
          this.selectedConversation.messages = updatedMessages;
        }
        
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      } else {
        console.log("⚠️ Message already exists or is duplicate, skipping");
      }
    },
    triggerFileSelect() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) {
        console.error("❌ No file selected!");
        return;
      }
      const type = file.type;

      if (type.startsWith("image/")) {
        this.sendMediaMessage(file, "image");
      } else if (type.startsWith("video/")) {
        this.sendMediaMessage(file, "video");
      } else if (type.startsWith("audio/")) {
        this.sendMediaMessage(file, "audio");
      } else {
        console.error("❌ Unsupported file type:", type);
      }
      this.selectedFile = file;
      const reader = new FileReader();
      reader.onload = async (e) => {
        this.previewImage = e.target.result;
        // this.sendMessage();
      };
      reader.onerror = (error) => {
        console.error("❌ Error reading file:", error);
      };

      reader.readAsDataURL(file);
    },
    formatFileSize(size) {
      const kb = size / 1024;
      return `${kb.toFixed(2)} KB`;
    },
    startRecording() {
      this.recorder
        .start()
        .then(() => {
          this.isRecording = true;
          console.log("🔴 Recording started...");
        })
        .catch((e) => {
          console.error("❌ Failed to start recording", e);
        });
    },
    stopRecording() {
      this.recorder
        .stop()
        .getMp3()
        .then(([buffer, blob]) => {
          const file = new File(buffer, "voice.mp3", {
            type: blob.type,
            lastModified: Date.now(),
          });

          this.audioUrl = URL.createObjectURL(blob);

          const formData = new FormData();
          formData.append("media", file);

          messageCenterApi
            .uploadMedia(file)
            .then((response) => {
              this.sendMediaMessage(file, "audio");
            })
            .catch((error) => {
              console.error("❌ Failed to upload media:", error);
            });

          console.log("✅ Recording ready:", file);
        })
        .catch((e) => {
          console.error("❌ Failed to get recording", e);
        })
        .finally(() => {
          this.isRecording = false;
        });
    },
    applyFilter(type) {
      this.selectedFilterType = type;
      this.showFilterMenu = false;
    },
    addEmoji(emoji) {
      this.newMessage += emoji;
      this.showEmojiPicker = false;
    },
    // getCurrentTime() {
    //   const now = new Date();
    //   const hours = String(now.getHours()).padStart(2, "0");
    //   const minutes = String(now.getMinutes()).padStart(2, "0");
    //   return `${hours}:${minutes}`;
    // },
    async fetchConversationMessages(conversationId) {
      try {
        // Filter by platform if specified
        const platform = this.currentPlatform === "whatsapp" ? "whatsapp" : null;
        const messages = await messageCenterApi.getConversationMessages(conversationId, 100, platform);
        this.selectedConversation.messages = messages.reverse();
        this.scrollToBottom();
      } catch (error) {
        console.error("❌ Failed to fetch messages:", error);
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messageContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },
    selectConversation(convo) {
      this.selectedConversation = convo;
      this.activeDmAccount = this.selectedDmAccounts.find(
        (account) => Number(account.id) === Number(convo.platform_account_id)
      ) || {
        id: convo.platform_account_id,
        platform: convo.platform,
        account_name: convo.account_name,
      };
      this.currentPlatform = String(convo.platform).toLowerCase() === "whatsapp" ? "whatsapp" : "meta";
      this.sender_id = convo.sender_id;
      this.selectedConversation.unread = false;
      this.fetchConversationMessages(convo.conversation_id);
    },
    selectPlatform(platform) {
      this.selectedPlatform = platform;
      const conversations = this.filteredConversations;
      if (conversations.length > 0) {
        this.selectedConversation = conversations[0];
      } else {
        this.selectedConversation = null;
      }
    },
    async sendMediaMessage(file, type) {
      if (!file || !["image", "video", "audio"].includes(type)) {
        console.error("❌ Invalid file or type");
        return;
      }

      // Check if conversation is selected
      if (!this.selectedConversation) {
        console.warn("❌ No conversation selected");
        this.avatarSkeleton = false;
        return;
      }

      this.avatarSkeleton = true;
      
      try {
        const res = await messageCenterApi.uploadMedia(file);
        const mediaUrl = res.url;
        const mimetype = file.type;
        const filename = file.name;
        const platform = this.activeDmAccount?.platform?.toLowerCase();

        // WhatsApp
        if (this.currentPlatform === "whatsapp" && this.whats_app_number) {
          socket.emit("send_message_whatsapp", {
            number: this.whats_app_number,
            media: { url: mediaUrl, mimetype, filename },
          });

          // Ensure reactive update using Vue.set
          if (!Array.isArray(this.selectedConversation.messages)) {
            if (this.$set) {
              this.$set(this.selectedConversation, 'messages', []);
            } else {
              this.selectedConversation.messages = [];
            }
          }
          
          // Create temporary message (will be replaced when socket responds with message_id)
          const newMessage = {
            type,
            direction: "outbound",
            media_url: mediaUrl,
            attachment: {
              url: mediaUrl,
              type: type,
              mime_type: mimetype,
            },
            sent_at: new Date().toISOString(),
            isTemporary: true, // Mark as temporary until socket responds with message_id
          };
          
          // Create new array and use $set for proper reactivity
          const updatedMessages = [...this.selectedConversation.messages, newMessage];
          if (this.$set) {
            this.$set(this.selectedConversation, 'messages', updatedMessages);
          } else {
            this.selectedConversation.messages = updatedMessages;
          }
        } else {
          // Facebook / Instagram
          if (!this.activeDmAccount) {
            console.warn("❌ No account selected for Meta platform");
            this.avatarSkeleton = false;
            return;
          }

          if (!this.sender_id) {
            console.warn("❌ No sender_id (recipient_id) selected");
            this.avatarSkeleton = false;
            return;
          }

          // Check 24-hour window restriction for Meta platforms
          if (!this.canSendMessage) {
            this.show24HourWarning = true;
            this.avatarSkeleton = false;
            console.warn("⚠️ Cannot send media: 24-hour window expired");
            return;
          }

          const eventName = 
            platform === "messenger" || platform === "facebook"
              ? "send_message_to_messenger"
              : platform === "instagram"
              ? "send_message_to_instagram"
              : null;

          if (!eventName) {
            console.error("❌ Unsupported platform:", platform);
            this.avatarSkeleton = false;
            return;
          }

          socket.emit(eventName, {
            page_id: this.activeDmAccount.page_id || this.activeDmAccount.account_id,
            recipient_id: this.sender_id,
            message: { type, content: mediaUrl },
          });

          // Ensure reactive update using Vue.set
          if (!Array.isArray(this.selectedConversation.messages)) {
            if (this.$set) {
              this.$set(this.selectedConversation, 'messages', []);
            } else {
              this.selectedConversation.messages = [];
            }
          }
          
          const newMessage = {
            type,
            direction: "outbound",
            media_url: mediaUrl,
            sent_at: new Date().toISOString(),
          };
          
          // Create new array and use $set for proper reactivity
          const updatedMessages = [...this.selectedConversation.messages, newMessage];
          if (this.$set) {
            this.$set(this.selectedConversation, 'messages', updatedMessages);
          } else {
            this.selectedConversation.messages = updatedMessages;
          }
        }

        this.previewImage = null;
        this.selectedFile = null;
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      } catch (err) {
        console.error("❌ Upload failed:", err);
      } finally {
        this.avatarSkeleton = false;
      }
    },
    sendMessage() {
      if (!this.newMessage.trim()) return;

      // Check if conversation is selected
      if (!this.selectedConversation) {
        console.warn("❌ No conversation selected");
        return;
      }

      // WhatsApp
      if (this.currentPlatform === "whatsapp" && this.whats_app_number) {
        const messageText = this.newMessage.trim();
        
        socket.emit("send_message_whatsapp", {
          number: this.whats_app_number,
          message: messageText,
        });

        // Ensure reactive update using Vue.set
        if (!Array.isArray(this.selectedConversation.messages)) {
          if (this.$set) {
            this.$set(this.selectedConversation, 'messages', []);
          } else {
            this.selectedConversation.messages = [];
          }
        }
        
        // Create temporary message (will be replaced when socket responds with message_id)
        const newMessage = {
          text: messageText,
          body: messageText,
          direction: "outbound",
          type: "text",
          sent_at: new Date().toISOString(),
          isTemporary: true, // Mark as temporary until socket responds with message_id
        };
        
        // Create new array and use $set for proper reactivity
        const updatedMessages = [...this.selectedConversation.messages, newMessage];
        if (this.$set) {
          this.$set(this.selectedConversation, 'messages', updatedMessages);
        } else {
          this.selectedConversation.messages = updatedMessages;
        }

        this.newMessage = "";
        this.$nextTick(() => {
          this.scrollToBottom();
        });
        return;
      }

      // Facebook / Instagram
      if (!this.activeDmAccount) {
        console.warn("❌ No account selected for Meta platform");
        return;
      }

      if (!this.sender_id) {
        console.warn("❌ No sender_id (recipient_id) selected");
        return;
      }

      // Check 24-hour window restriction for Meta platforms
      if (!this.canSendMessage) {
        this.show24HourWarning = true;
        console.warn("⚠️ Cannot send message: 24-hour window expired");
        return;
      }

      const platform = this.activeDmAccount?.platform?.toLowerCase();
      const eventName = 
        platform === "messenger" || platform === "facebook"
          ? "send_message_to_messenger"
          : platform === "instagram"
          ? "send_message_to_instagram"
          : null;

      if (!eventName) {
        console.error("❌ Unsupported platform:", platform);
        return;
      }

      const messageText = this.newMessage.trim();
      
      socket.emit(eventName, {
        page_id: this.activeDmAccount.page_id || this.activeDmAccount.account_id,
        recipient_id: this.sender_id,
        message: { content: messageText, type: "text" },
      });

      // Ensure reactive update using Vue.set
      if (!Array.isArray(this.selectedConversation.messages)) {
        if (this.$set) {
          this.$set(this.selectedConversation, 'messages', []);
        } else {
          this.selectedConversation.messages = [];
        }
      }
      
      const newMessage = {
        text: messageText,
        body: messageText,
        direction: "outbound",
        type: "text",
        sent_at: new Date().toISOString(),
      };
      
      // Create new array and use $set for proper reactivity
      const updatedMessages = [...this.selectedConversation.messages, newMessage];
      if (this.$set) {
        this.$set(this.selectedConversation, 'messages', updatedMessages);
      } else {
        this.selectedConversation.messages = updatedMessages;
      }

      this.newMessage = "";
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    handleAccountsSelected(accounts) {
      const uniqueAccounts = [...new Map(accounts.map((account) => [Number(account.id), account])).values()];
      this.selectedDmAccounts = uniqueAccounts;
      this.currentPage = 1;
      this.selectedConversation = null;
      this.conversations = [];
      clearTimeout(this.accountSelectionTimer);
      if (!uniqueAccounts.length) return;
      this.accountSelectionTimer = setTimeout(() => this.getConversations(1), 300);
    },
    refreshConversations() {
      if (this.selectedDmAccounts.length) this.getConversations(this.currentPage || 1);
    },
    conversationPlatformIcon(platform) {
      return { facebook_messenger: "mdi-facebook", facebook: "mdi-facebook", messenger: "mdi-facebook", instagram: "mdi-instagram", whatsapp: "mdi-whatsapp" }[String(platform).toLowerCase()] || "mdi-message-text";
    },
    getCurrentTime() {
      const now = new Date();
      return now
        .toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
        .toLowerCase();
    },
    handleScroll(event) {
      const target = event.target;
      const nearBottom =
        target.scrollHeight - target.scrollTop <= target.clientHeight + 50;

      if (!nearBottom || this.isLoadingMore) return;

      if (this.currentPage < this.totalPages) {
        this.getConversations(this.currentPage + 1, true);
      }
    },
    async getConversations(page = 1, append = false) {
      if (!this.selectedDmAccounts.length) return;
      if (this.isLoadingConversations || this.isLoadingMore) return;
      if (append) this.isLoadingMore = true;
      else this.isLoadingConversations = true;

      let retryWithAvailableAccounts = false;
      try {
        const { data, pagination } = await messageCenterApi.getConversations(
          this.selectedDmAccounts.map(({ id }) => id),
          page,
          20
        );

        this.currentPage = pagination.current_page;
        this.totalPages = pagination.total_pages;

        if (append) {
          this.conversations = [...this.conversations, ...data];
        } else {
          this.conversations = data;
        }
      } catch (error) {
        const accountIdsError = error.response?.status === 422 && error.response?.data?.errors?.account_ids;
        if (accountIdsError && this.$refs.accountSelector) {
          const availableAccounts = await this.$refs.accountSelector.refreshAvailableAccounts();
          this.selectedDmAccounts = availableAccounts;
          this.selectedConversation = null;
          this.conversations = [];
          this.currentPage = 1;
          retryWithAvailableAccounts = availableAccounts.length > 0;
        }
        console.error("❌ Error fetching conversations:", error);
      } finally {
        this.isLoadingConversations = false;
        this.isLoadingMore = false;
        if (retryWithAvailableAccounts) this.getConversations(1);
      }
    },
    openImageDialog(url) {
      this.previewDialogImage = url;
      this.previewDialog = true;
    },
    onEmojiClick(event) {
      const emoji = event.detail.unicode;
      this.newMessage += emoji;
      this.showEmojiPicker = false;
    },

    async getWhatsAppChats(loadMore = false) {
      if (this.isLoadingConversations) return;
      this.isLoadingConversations = true;
      this.isLoadingMore = loadMore;

      try {
        const { chats, pagination } = await messageCenterApi.getWhatsAppChats(
          this.whatsappPage,
          this.whatsappPerPage
        );

        if (loadMore) {
          this.whatsappChats.push(...chats);
        } else {
          this.whatsappChats = chats;
        }

        this.whatsappPage = pagination.current_page + 1;
        this.whatsappTotalPages = pagination.total_pages;
      } catch (err) {
        console.error("❌ Failed to load chats", err);
      } finally {
        this.isLoadingConversations = false;
        this.isLoadingMore = false;
      }
    },
    async selectWhatsAppChat(chat) {
      try {
        const messages = await messageCenterApi.getWhatsAppMessages(chat.id, 1, 1250);

        this.whats_app_number = chat.id.slice(0, -5);
        this.selectedWhatsappChat = chat.id;
        this.selectedConversation = {
          ...chat,
          messages,
          page: 1,
          per_page: 1250,
          hasMore: messages.length === 1250,
        };

        this.scrollToBottom();

        const index = this.whatsappChats.findIndex((c) => c.id === chat.id);
        if (index !== -1) {
          this.whatsappChats[index].unreadCount = 0;
          this.whatsappChats[index].unread = false;
        }
      } catch (err) {
        console.error("❌ Failed to load WhatsApp messages:", err);
      }
    },
    async loadMoreWhatsAppMessages() {
      const convo = this.selectedConversation;
      if (!convo || !convo.hasMore || this.isLoadingMessages) return;

      this.isLoadingMessages = true;

      try {
        const chatId = `${this.whats_app_number}@c.us`;
        const newMessages = await messageCenterApi.getWhatsAppMessages(
          chatId,
          convo.page + 1,
          convo.per_page
        );

        const container = this.$refs.messageContainer;
        const oldHeight = container?.scrollHeight || 0;

        convo.messages = [...newMessages, ...convo.messages];
        convo.page += 1;
        convo.hasMore = newMessages.length === convo.per_page;

        this.$nextTick(() => {
          if (container) {
            const newHeight = container.scrollHeight;
            container.scrollTop = newHeight - oldHeight;
          }
        });
      } catch (err) {
        console.error("❌ Failed to load older WhatsApp messages", err);
      } finally {
        this.isLoadingMessages = false;
      }
    },
    handleMessageScroll(e) {
      const container = e.target;
      if (container.scrollTop < 50 && !this.isLoadingMessages) {
        this.loadMoreWhatsAppMessages();
      }
    },
  },
  mounted() {
    this.newMessageSound = new Audio(
      require("@/assets/audio/new-notification-09-352705.mp3")
    );
    this.newMessageSound.volume = 0.6;
    
    // Connect socket immediately
    if (!socket.connected) {
      console.log('🔌 Connecting socket...');
      socket.connect();
    }
    
    // Setup socket health check
    this.setupHealthCheck();
    
    // Setup socket event listeners for connection status
    socket.on('connect', () => {
      console.log('✅ Socket connected:', socket.id);
      this.socketConnected = true;
      this.reconnectAttempts = 0;
    });
    
    socket.on('disconnect', (reason) => {
      console.warn('⚠️ Socket disconnected:', reason);
      this.socketConnected = false;
    });
    
    socket.on('connect_error', (error) => {
      console.error('❌ Socket connection error:', error.message);
      this.socketConnected = false;
    });
    
    socket.on('message_sent', (data) => {
      console.log('✅ Message sent confirmation:', data);
      // Update message status if needed
    });
    
    socket.on('error', (error) => {
      console.error('❌ Socket error:', error);
      this.$notify?.({
        type: 'error',
        title: 'Message Error',
        message: error.message || 'Failed to send message'
      });
    });
    
    console.log('🎧 Registering socket event listener for new_message');
    
    socket.on("new_message", (data) => {
      console.log("📨 New message received:", data);
      console.log("📊 Current platform:", this.currentPlatform);
      console.log("📊 Selected conversation:", this.selectedConversation?.id);
      
      const wid = data.from;
      const text = data.body || data.text || "[No Text]";
      
      // Handle timestamp - new format uses milliseconds, old format used seconds
      let timestamp = new Date().toISOString();
      if (data.timestamp && !isNaN(data.timestamp)) {
        try {
          // If timestamp is in milliseconds (>= 1e12), use as is
          // If timestamp is in seconds (< 1e12), convert to milliseconds
          const timestampMs = data.timestamp >= 1e12 
            ? data.timestamp 
            : data.timestamp * 1000;
          timestamp = new Date(timestampMs).toISOString();
        } catch (e) {
          console.warn("⏱️ Invalid timestamp:", data.timestamp);
        }
      } else if (data.sent_at) {
        timestamp = data.sent_at;
      }

      // Play sound for incoming messages (only for inbound messages, not outbound)
      if (
        data.direction === "inbound" &&
        this.newMessageSound &&
        typeof this.newMessageSound.play === "function"
      ) {
        this.newMessageSound.play().catch(() => {
          // Sound blocked by browser - ignore
        });
      }

      // WhatsApp handling - Check if message has new format (conversation_id/chat_id) or old format (@c.us, @lid, @g.us pattern)
      const isWhatsAppMessage = 
        (data.conversation_id && (
          data.conversation_id.includes("@c.us") ||
          data.conversation_id.includes("@lid") ||
          data.conversation_id.includes("@g.us")
        )) ||
        (data.chat_id && (
          data.chat_id.includes("@c.us") ||
          data.chat_id.includes("@lid") ||
          data.chat_id.includes("@g.us")
        )) ||
        (wid && (
          wid.includes("@c.us") ||
          wid.includes("@lid") ||
          wid.includes("@g.us")
        )) ||
        (data.sender_id && (
          data.sender_id.includes("@c.us") ||
          data.sender_id.includes("@lid") ||
          data.sender_id.includes("@g.us")
        )) ||
        (data.to && (
          data.to.includes("@c.us") ||
          data.to.includes("@lid") ||
          data.to.includes("@g.us")
        ));

      if (isWhatsAppMessage) {
        console.log("✅ WhatsApp message detected");
        
        // Check for duplicate using message_id before processing
        if (this.isWhatsAppDuplicate(data)) {
          console.log("⚠️ Duplicate WhatsApp message detected, skipping:", data.message_id);
          return;
        }

        // Normalize message to consistent format
        const normalized = this.normalizeWhatsAppMessage(data);
        console.log("📝 Normalized message:", normalized);

        // Play sound for incoming messages
        if (
          normalized.direction === "inbound" &&
          this.newMessageSound &&
          typeof this.newMessageSound.play === "function"
        ) {
          this.newMessageSound.play().catch(() => {
            // Sound blocked by browser - ignore
          });
        }

        // Update conversation list
        console.log("📋 Updating WhatsApp chat list...");
        this.updateWhatsAppChatList(data);

        // Find matching chat (after updating list, in case a new chat was created)
        const matchingChat = this.checkWhatsAppConversationMatch(data);
        console.log("🔍 Matching chat found:", matchingChat?.id || "none");

        // Check if this message belongs to the currently selected conversation
        // Match by conversation_id/chat_id or by id
        const isSelectedConversation = this.selectedConversation && (
          (normalized.conversation_id && (
            this.selectedConversation.id === normalized.conversation_id ||
            this.selectedConversation.conversation_id === normalized.conversation_id ||
            this.selectedConversation.chat_id === normalized.conversation_id
          )) ||
          (normalized.chat_id && (
            this.selectedConversation.id === normalized.chat_id ||
            this.selectedConversation.conversation_id === normalized.chat_id ||
            this.selectedConversation.chat_id === normalized.chat_id
          )) ||
          (matchingChat && (
            this.selectedConversation.id === matchingChat.id ||
            this.selectedConversation.conversation_id === matchingChat.conversation_id ||
            this.selectedConversation.chat_id === matchingChat.chat_id
          ))
        );

        // If this chat is currently open, add message to selected conversation
        console.log("🎯 Is selected conversation:", isSelectedConversation);
        
        if (isSelectedConversation) {
          console.log("✅ Adding message to selected conversation");
          
          // Check if there's a temporary message to replace (only for outbound messages)
          if (normalized.message_id && normalized.direction === "outbound") {
            const tempMessageIndex = this.selectedConversation.messages.findIndex(
              (msg) =>
                msg.isTemporary &&
                msg.direction === "outbound" &&
                ((msg.text === normalized.text || msg.body === normalized.body) ||
                 (msg.media_url === normalized.media_url && normalized.media_url)) &&
                Math.abs(new Date(msg.sent_at).getTime() - normalized.timestamp) < 5000
            );

            if (tempMessageIndex !== -1) {
              // Replace temporary message with real one
              console.log("🔄 Replacing temporary message with real message_id");
              const updatedMessages = [...this.selectedConversation.messages];
              updatedMessages[tempMessageIndex] = normalized;
              if (this.$set) {
                this.$set(this.selectedConversation, 'messages', updatedMessages);
              } else {
                this.selectedConversation.messages = updatedMessages;
              }
            } else {
              // Add new message
              console.log("➕ Adding new outbound message (no temp found)");
              this.addMessageToSelectedConversation(normalized, normalized.sent_at);
            }
          } else {
            // No message_id, add as new message
            console.log("➕ Adding new message (inbound or no message_id)");
            this.addMessageToSelectedConversation(normalized, normalized.sent_at);
          }
        } else {
          console.log("ℹ️ Message not for selected conversation - updating chat list only");
        }

        console.log("✅ WhatsApp message processing complete");
        return;
      }

      // Messenger / Instagram handling
      const dataConvId = String(data.conversation_id || '');
      
      // First, try to find conversation in list that matches the socket conversation_id (t_...)
      // The socket sends thread_id format (t_3930160183864247) which matches api_conversation_id from API
      const matchingConversation = this.conversations.find(
        (conv) => {
          // Check api_conversation_id (the field that matches socket conversation_id)
          const convApiId = String(conv.api_conversation_id || '');
          const convId = String(conv.conversation_id || '');
          const convThreadId = String(conv.thread_id || conv.threadId || conv.facebook_thread_id || '');
          // Match by api_conversation_id (primary), or other thread_id fields
          return convApiId === dataConvId || convThreadId === dataConvId || 
                 (convId.startsWith('t_') && convId === dataConvId);
        }
      );
      
      // Check if selected conversation matches
      const selectedConvId = String(this.selectedConversation?.conversation_id || '');
      // Use api_conversation_id from selectedConversation (this is what matches socket conversation_id)
      const selectedApiConvId = String(
        this.selectedConversation?.api_conversation_id || 
        this.selectedConversation?.thread_id || 
        this.selectedConversation?.threadId || 
        this.selectedConversation?.facebook_thread_id || 
        ''
      );
      const selectedSenderId = String(this.selectedConversation?.sender_id || '');
      const dataSenderId = String(data.sender_id || '');
      
      // Match by api_conversation_id (primary match), or by sender_id as fallback
      const matchesByApiConvId = selectedApiConvId === dataConvId;
      const matchesBySenderId = selectedSenderId && dataSenderId && selectedSenderId === dataSenderId;
      const isMatchingConversation = matchingConversation && 
        this.selectedConversation && 
        (matchingConversation.conversation_id === this.selectedConversation.conversation_id ||
         String(matchingConversation.sender_id) === String(this.selectedConversation.sender_id));
      
      console.log("🔍 Checking conversation match:", {
        selectedConversationId: selectedConvId,
        selectedApiConversationId: selectedApiConvId,
        dataConversationId: dataConvId,
        selectedSenderId: selectedSenderId,
        dataSenderId: dataSenderId,
        matchByApiConvId: matchesByApiConvId,
        matchBySenderId: matchesBySenderId,
        isMatchingConversation: isMatchingConversation,
        matchingConversationFound: !!matchingConversation,
        matchingConversationId: matchingConversation?.conversation_id
      });

      // Check if this message belongs to the currently selected conversation
      // Match by api_conversation_id (primary) OR by sender_id (fallback) OR if matchingConversation is the selected one
      if (
        this.selectedConversation &&
        (matchesByApiConvId || matchesBySenderId || isMatchingConversation)
      ) {
        console.log("✅ Conversation matched, adding message");
        
        // Use the helper method to add message safely
        this.addMessageToSelectedConversation(data, timestamp);
      } else {
        console.log("❌ Conversation not matched or not selected");
        
        // Try to find conversation by socket conversation_id in the list
        // This handles cases where API returns numeric ID but socket sends thread_id (t_...)
        if (data.conversation_id) {
          const conversationBySocketId = this.conversations.find(
            (conv) => {
              // Check api_conversation_id (primary match) or other thread_id fields
              const convApiId = String(conv.api_conversation_id || '');
              const convThreadId = String(conv.thread_id || conv.threadId || '');
              const convId = String(conv.conversation_id || '');
              const socketConvId = String(data.conversation_id);
              
              return convApiId === socketConvId || convThreadId === socketConvId || convId === socketConvId;
            }
          );
          
          // If found conversation in list, either select it or add message to it
          if (conversationBySocketId) {
            // If no conversation is selected, auto-select the matching one
            if (!this.selectedConversation) {
              console.log("✅ Auto-selecting matching conversation");
              this.selectConversation(conversationBySocketId);
              // Wait a bit for conversation to be selected, then add message
              this.$nextTick(() => {
                this.addMessageToSelectedConversation(data, timestamp);
              });
            } 
            // If selected conversation matches the found one, add message
            else if (conversationBySocketId.conversation_id === this.selectedConversation.conversation_id ||
                     String(conversationBySocketId.sender_id) === String(this.selectedConversation.sender_id)) {
              console.log("✅ Matched conversation from list, adding message");
              this.addMessageToSelectedConversation(data, timestamp);
            }
          }
        }
      }

      // Update conversation list
      const index = this.conversations.findIndex(
        (c) => String(c.conversation_id) === String(data.conversation_id) ||
               (data.sender_id && String(c.sender_id) === String(data.sender_id))
      );

      if (index !== -1) {
        if (this.$set) {
          this.$set(this.conversations[index], 'last_message_text', data.text || data.content || "[Attachment]");
          this.$set(this.conversations[index], 'unread', true);
        } else {
          this.conversations[index].last_message_text = data.text || data.content || "[Attachment]";
          this.conversations[index].unread = true;
        }
        const updatedConvo = this.conversations.splice(index, 1)[0];
        this.conversations.unshift(updatedConvo);
      }
    });

  },
  beforeUnmount() {
    clearTimeout(this.accountSelectionTimer);
    // Cleanup socket listeners
    socket.off("new_message");
    socket.off("message_sent");
    socket.off("error");
    socket.off("connect");
    socket.off("disconnect");
    socket.off("connect_error");
    
    // Clear health check interval
    if (this.socketHealthCheck) {
      clearInterval(this.socketHealthCheck);
      this.socketHealthCheck = null;
    }
  },
};
</script>

<style scoped>
.flex-grow-1 {
  flex-grow: 1;
}

.h-100 {
  height: 100%;
}

.msgbox {
  width: 93%;
}

.chatwindow {
  height: 80vh;
}

.chatside {
  height: 80vh;
}
.recording-animation {
  animation: pulse 1s infinite;
  background-color: #ff5252 !important; /* أحمر للتسجيل */
  color: white !important;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}
.search-conversation {
  display: flex;
  align-items: center;
  border: 1px solid #cccccc;
  border-radius: 8px;
  padding: 0 8px;
}

input {
  width: 100%;
  padding: 4px 2px;
  font-size: 14px;
  outline: none;
  box-shadow: none;
  transition: border-color 0.2s;
}
.badge {
  width: 10px;
  height: 10px;
  background-color: green;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 0;
  border: 2px solid #fff;
}
</style>
